
export default {
  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    paramsList: function () {
      let characteristics = [];
      (this.product?.characteristics || []).map((t) => {
        characteristics.push(...(t?.characteristics || []))
      });

      let list = [];

      // Грузоподъёмность
      const gruzopodemnost = characteristics.find((t) => t.slug === 'gruzopodemnost');
      if (!!gruzopodemnost) {
        let values = [];
        (gruzopodemnost.values || []).map((t) => (t.value || '').split('-')).map((t) => values.push(...t));
        const maxValue = Math.max(...[...values].map((t) => Number.parseFloat(t)));
        const unit = String(gruzopodemnost?.unit || '').toLowerCase()
        list.push({ label: 'Грузоподъёмность', value: [maxValue, unit].filter((t) => !!t).join(' ') });
      }

      // Погрузочная высота
      const vysota = characteristics.find((t) => t.slug === 'vysota');
      if (!!vysota) {
        const unit = String(vysota?.unit || '').toLowerCase()
        list.push({ label: 'Погрузочная высота', value: [vysota?.values?.[0]?.value, unit].filter((t) => !!t).join(' ') });
      }

      // Погрузочная длина
      const dlinna = characteristics.find((t) => t.slug === 'dlinna');
      if (!!dlinna) {
        const unit = String(dlinna?.unit || '').toLowerCase()
        list.push({ label: 'Погрузочная длина', value: [dlinna?.values?.[0]?.value, unit].filter((t) => !!t).join(' ') });
      }

      // Ширина
      const shirina = characteristics.find((t) => t.slug === 'shirina');
      if (!!shirina) {
        const unit = String(shirina?.unit || '').toLowerCase()
        list.push({ label: 'Ширина', value: [shirina?.values?.[0]?.value, unit].filter((t) => !!t).join(' ') });
      }


      return list
    },
    buttonLabel: function () {
      let characteristics = [];
      (this.product?.characteristics || []).map((t) => {
        characteristics.push(...(t?.characteristics || []))
      });

      const transport = characteristics.find((t) => t.slug === 'transport')?.values?.[0]?.value || '';
      if (!transport) {
        return 'Заказать'
      }

      return `Заказать ${String(transport).toLowerCase()}`
    },
  },

  methods: {
     openForm: function () {
       this.$store.commit("back-call/setOpen", {
         open: true,
         settings: {
           type: 'Оставить заявку',
           hideTabs: true
         }
       });
     }
  }
}
